import Vue from "vue";
import VueI18n from "vue-i18n";

// Localisation language list
import { locale as en } from "@/i18n/en-us/index";
import { locale as de } from "@/i18n/de-de/index";

Vue.use(VueI18n);
// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: toLocaleCode(localStorage.getItem("language") ?? "de") || "de-de", // set locale
  messages: { "en-us": en, "de-de": de } // set locale messages
});

function toLocaleCode(lang = "de") {
  const defaults = {
    de: "de-de",
    en: "en-us"
  };
  // normalize to lowercase
  const code = lang.toLowerCase();

  return defaults[code] ?? code;
}

export function toRegionalCode(lang = "de-de") {
  return lang.split("-")[0] ?? "de";
}

export default i18n;
